const Filler: React.FC = () => {
  return (
    <div className="z-[-1] block h-[1px] w-full max-w-full opacity-0">
      <span className="h-auto w-auto min-w-[1px] break-words">
        this is the cheat code that I am using in order to make stubborn
        children (who does not follow flex-grow) follow their parents
        (max-width)
      </span>
    </div>
  )
}

export default Filler
